import { orderPaymentMethodMap } from '@utils/filter-value-to-text'
import { StatusMetaMap } from './statusMap'

const DEFAULT_META = {
  label: '-',
  color: '#D4D9DB',
  textColor: '#6C6B6B',
}

/** 操作類 action → 顯示文字 + 沿用哪個 StatusMetaMap 配色（或直接指定 color） */
export const HistoryActionMetaMap = {
  CREATE: { label: '建立訂單', statusKey: 'PENDING' },
  CONFIRM: { label: '接受訂單', statusKey: 'UNPAID' },
  REJECT: { label: '拒絕訂單', statusKey: 'CANCEL' },
  UPDATE: { label: '狀態更新', useEntryStatus: true },
  REFUND: { label: '已退款', color: '#E6A23C', textColor: '#FFFFFF' },
  RESCHEDULE: { label: '修改日期' },
}

export function resolveStatusLabel(statusKey) {
  const key = String(statusKey || '').toUpperCase()
  if (!key) return ''
  return StatusMetaMap[key]?.label || statusKey
}

function formatHistoryDate(dateStr) {
  if (!dateStr) return ''
  return String(dateStr).replace(/-/g, '/')
}

/**
 * 將 histories[].log 物件轉為可讀主文（不含 createdBy）
 */
export function formatHistoryLog(entry) {
  const log = entry?.log
  if (!log || typeof log !== 'object') return ''

  const statusChange = log.status
  if (statusChange && typeof statusChange === 'object' && statusChange.original != null && statusChange.updated != null) {
    return `${resolveStatusLabel(statusChange.original)} → ${resolveStatusLabel(statusChange.updated)}`
  }

  if (typeof statusChange === 'string' && statusChange) {
    const parts = [resolveStatusLabel(statusChange)]
    if (log.check_in_date) {
      parts.push(`入住 ${formatHistoryDate(log.check_in_date)}`)
    }
    if (log.check_out_date) {
      parts.push(`退房 ${formatHistoryDate(log.check_out_date)}`)
    }
    return parts.join(' · ')
  }

  return ''
}

export function resolveHistoryActionMeta(action, status) {
  const actionKey = String(action || '').toUpperCase()
  const statusKey = String(status || '').toUpperCase()
  const key = actionKey || statusKey
  if (!key) return { ...DEFAULT_META, label: '-' }

  const actionMeta = HistoryActionMetaMap[key]
  if (actionMeta) {
    if (actionMeta.color) {
      return {
        label: actionMeta.label,
        color: actionMeta.color,
        textColor: actionMeta.textColor || DEFAULT_META.textColor,
      }
    }
    const colorKey = actionMeta.useEntryStatus ? statusKey : actionMeta.statusKey
    const style = (colorKey && StatusMetaMap[colorKey]) || DEFAULT_META
    return {
      label: actionMeta.label,
      color: style.color,
      textColor: style.textColor,
    }
  }

  const statusMeta = StatusMetaMap[key]
  if (statusMeta) {
    return {
      label: statusMeta.label,
      color: statusMeta.color,
      textColor: statusMeta.textColor,
    }
  }

  return {
    label: action || status || '-',
    color: DEFAULT_META.color,
    textColor: DEFAULT_META.textColor,
  }
}

export function formatHistoryMainLine(entry) {
  const parts = [formatHistoryLog(entry), entry?.createdBy].filter(Boolean)
  return parts.join(' - ')
}

const PAYMENT_METHOD_REASON_RE = /^付款方式:\s*(.+)$/

export function formatHistoryReason(reason, action) {
  const text = String(reason || '').trim()
  if (!text) return ''

  if (text.toUpperCase() === 'RESCHEDULE') {
    return '修改日期'
  }

  const match = text.match(PAYMENT_METHOD_REASON_RE)
  if (match) {
    const method = match[1].trim()
    const label = orderPaymentMethodMap[method] || method
    return `付款方式: ${label}`
  }

  const actionKey = String(action || '').toUpperCase()
  if (actionKey === 'REFUND' && !text.startsWith('退款原因：')) {
    return `退款原因：${text}`
  }

  return text
}

export function resolveHistoryTagKey(entry) {
  return entry?.action || entry?.status || ''
}
